import apis from '@/assets/js/apis'
import auth from '@/assets/js/auth'

const login = {
  methods: {
    checkLogin () {
      const token = auth.checkAuth()

      // 若找不到 Cookie
      if (!token) {
        this.$router.push({ name: 'login' })
        return false
      } else {
        this.$store.commit('setToken', token)
        this.setSchool(token)
        this.setInfo(token)
        return true
      }
    },
    async setSchool (token) {
      this.$store.commit('setUserInfo', await apis.school.get(token))

      return true
    },
    // 設定 form 的資訊（有哪些年度等...）
    async setInfo (token) {
      const info = await apis.info.get(token)
      this.$store.commit('setFormInfo', info.formInfo)
      this.$store.commit('setLotteryInfo', info.lotteryInfo)

      return true
    },
  },
}

export { login }
